import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

type SalesScriptAuthData = {
  country?: string
  commonData?: { salesScriptEnabled?: boolean }
}

export const isSalesScriptAvailable = ({ country = '', commonData }: SalesScriptAuthData): boolean =>
  // @ts-ignore
  Boolean(modulesConfig[country]?.customer?.salesScript) && commonData?.salesScriptEnabled === true
